import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/BrandLeaderBoardSagas";

const FilterByView = () => {
  const dispatch = useDispatch();
  const displayViewDropdown = useSelector(
    (state) => state.brandLeaderboard.currentUser.displayViewDropdown
  );
  const viewOptions = useSelector((state) => state.brandLeaderboard.viewOptions);
  const selectedViewOption = useSelector((state) => state.brandLeaderboard.selectedViewOption);

  return displayViewDropdown ? (
    <div className="view-select-box">
      <p>View</p>
      <MultiSelectDropdown
        options={viewOptions}
        selectedFilters={selectedViewOption}
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.updateView(data))}
      />
    </div>
  ) : null;
};

export default FilterByView;
